import {Injectable} from '@angular/core';

/** Безопасно парсит данные */
function tryParseData(data: any) {
    try {
        return JSON.parse(data);
    } catch (e) {
        return data;
    }
}

/** Сервис для работы с postMessage */
@Injectable()
export class PostMessageService {

    /** Список слушателей события message */
    private _listeners: Function[] = [];

    /** Отправляет данные postMessage адресуемому окну */
    static sendTo(target: Window, data: any) {
        target.postMessage(data, '*');
    }

    constructor() {
        window.addEventListener('message', (e: MessageEvent) => {
            const data = tryParseData(e.data);
            this._listeners.forEach(fn => {
                fn.call(window, data);
            });
        });
    }

    /** Добавляет слушателя события message */
    on(callback: Function): void {
        if (typeof callback === 'function') {
            this._listeners.push(callback);
        }
    }

    /** Удаляет слушателя события message */
    off(callback: Function): void {
        for (let i = 0; i < this._listeners.length; i++) {
            if (callback === this._listeners[i]) {
                this._listeners.splice(i, 1);
            }
        }
    }

    /** Отправляет данные postMessage адресуемому окну */
    sendTo(target: Window, data: any) {
        PostMessageService.sendTo(target, data);
    }

}